module.exports = __webpack_public_path__ + "img/RING.ddb4be74.webp";